/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;
module.exports = reEscape;